import React from 'react';
import { MessageCircle, Bug, Zap, DollarSign, PlayCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ChatHeader = ({
  sessionName = "Chat",
  sessionId,
  connectionStatus = 'disconnected',
  totalTokens = 0,
  totalCost = 0,
  showDebugButton = true,
  showMetrics = true,
  draftData = null,
  onResumeWorkflow = null
}) => {
  const navigate = useNavigate();

  const handleOpenDebug = () => {
    if (sessionId) {
      navigate(`/debug?execution=${sessionId}&type=v2`);
    }
  };

  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800">
      <div className="flex items-center space-x-3">
        <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
          <MessageCircle className="w-6 h-6 text-blue-600 dark:text-blue-400" />
        </div>
        <div>
          <h1 className="text-lg font-semibold text-gray-900 dark:text-white">{sessionName}</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">AI Conversation</p>
        </div>
      </div>
      
      <div className="flex items-center space-x-2">
        {showMetrics && (
          <div className="flex items-center space-x-4 text-xs text-gray-500 dark:text-gray-400">
            <span className="flex items-center">
              <Zap className="w-3 h-3 mr-1" />
              {totalTokens} tokens
            </span>
            <span className="flex items-center">
              <DollarSign className="w-3 h-3 mr-1" />
              ${totalCost.toFixed(4)}
            </span>
            <div className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs ${
              connectionStatus === 'connected' ? 'bg-green-100 text-green-700 dark:bg-green-900/20 dark:text-green-400' : 'bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-400'
            }`}>
              <div className={`w-2 h-2 rounded-full ${
                connectionStatus === 'connected' ? 'bg-green-500' : 'bg-red-500'
              }`} />
              <span>{connectionStatus}</span>
            </div>
          </div>
        )}

        {draftData && onResumeWorkflow && (
          <button
            onClick={onResumeWorkflow}
            className="flex items-center space-x-2 px-3 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg hover:from-blue-600 hover:to-purple-600 transition-all shadow-md hover:shadow-lg"
            title="Resume Workflow Setup"
          >
            <PlayCircle className="w-4 h-4" />
            <span className="text-sm font-medium">Resume Setup</span>
          </button>
        )}

        {showDebugButton && sessionId && (
          <button
            onClick={handleOpenDebug}
            className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            title="View Debug Logs"
          >
            <Bug className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatHeader;